import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-arrow-up-left",
  templateUrl: "./med-icon-arrow-up-left.component.html",
})
export class MedIconArrowUpLeftComponent extends SvgMixinComponent {}
